import * as yup from "yup";

const validator = (
  messages,
  { deltaRia, deltaStart, deltaEndRia, deltaEnd },
) => {
  return yup.object().shape({
    contract: yup.object().shape({
      issuanceDate: yup
        .date()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED),
    }),
    fields: yup.object().shape({
      familyStatus: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthCountry: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthDepartment: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      profession: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      hasExistingContract: yup.boolean(),
      contractMoreThanOneYear: yup.boolean(),
      selfOccupation: yup.boolean().nullable(),
      isPPE: yup.boolean(),
      ppeFunction: yup.string().when("isPPE", {
        is: true,
        then: yup
          .string()
          .typeError(messages.REQUIRED)
          .required(messages.REQUIRED),
        otherwise: yup.string().typeError(messages.REQUIRED).nullable(),
      }),
      ppeRelated: yup
        .boolean()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED),
    }),
    terminationRequest: yup.mixed().when(["fields.selfOccupation"], {
      is: (selfOccupation) => {
        return selfOccupation === false;
      },
      then: yup
        .object()
        .typeError(messages.REQUIRED)
        .shape({
          contractNumber: yup
            .string()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED),
          dueDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED),
          recipient: yup
            .string()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED),
          reason: yup
            .string()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED),
        }),
    }),
  });
};

export default validator;
